/* eslint-disable */ import { createPresetsFactory } from '@salsita-ai/platform-project-sdk/domain';
export const createPresets = createPresetsFactory();
export const generatedPresets = createPresets([
    {
        name: 'Default',
        description: 'Initial scene',
        rootEntityType: 'Scene',
        initialDomainEntities: [
            {
                id: 'Scene-1',
                type: 'Scene',
                cabinetColor: 'Gray',
                hasDifferentWallCabinetColor: false,
                wallCabinetColor: 'Black',
                countertopColor: 'Black Plastic Laminate',
                hardwareMaterial: 'black',
                floorTexture: 'concrete',
                includeCountertop: true,
                showPrices: false
            }
        ]
    }
]);

//# sourceMappingURL=presets.js.map